import { render, staticRenderFns } from "./surveyList.vue?vue&type=template&id=74832b36&scoped=true"
import script from "./surveyList.vue?vue&type=script&lang=js"
export * from "./surveyList.vue?vue&type=script&lang=js"
import style0 from "./surveyList.vue?vue&type=style&index=0&id=74832b36&prod&lang=scss&scoped=true"
import style1 from "./surveyList.vue?vue&type=style&index=1&id=74832b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74832b36",
  null
  
)

export default component.exports